import { ExtraTool, ExtraToolBooking } from "models";
 

export default class ExtraToolBookingViewModel extends ExtraToolBooking{
    extraTool?:ExtraTool;
}